import type { FragmentOf } from "@opensea/graphql"
import { readFragment } from "@opensea/graphql"
import {
  classNames,
  Flex,
  FlexColumn,
  NumberDisplay,
  SkeletonLine,
  TextBody,
  TextDisplay,
} from "@opensea/ui-kit"
import { ViewWalletPortfolioValueFragment } from "./ViewWalletPortfolioValue.fragment"

type Props = {
  portfolioValue: FragmentOf<typeof ViewWalletPortfolioValueFragment>
  className?: string
}

export function ViewWalletPortfolioValue({
  portfolioValue: portfolioValueKey,
  className,
}: Props) {
  const portfolioValue = readFragment(
    ViewWalletPortfolioValueFragment,
    portfolioValueKey,
  )

  return (
    <FlexColumn className={classNames("gap-1 px-0", className)}>
      <TextDisplay size="sm">
        <NumberDisplay
          suffix={portfolioValue.native.symbol}
          value={portfolioValue.native.unit}
        />
      </TextDisplay>
      <TextBody color="text-secondary" size="sm">
        <NumberDisplay display="usd" value={portfolioValue.usd} />
      </TextBody>
    </FlexColumn>
  )
}

export function ViewWalletPortfolioValueSkeleton() {
  return (
    <FlexColumn className="gap-1 px-0">
      <TextDisplay size="sm">
        <SkeletonLine className="h-8 w-[8ch]" />
      </TextDisplay>
      <Flex className="h-4 items-center">
        <SkeletonLine className="h-[14px] w-[90px]" />
      </Flex>
    </FlexColumn>
  )
}
